import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import { Link } from 'react-router-dom'
const CampusInformation = () => {
    return (
        <>
            <Header />

            <Breadcrumb title="CBSE Mandatory Disclosure" midBreadcrumb="School" mainBreadcrumb="CBSE Mandatory Disclosure" ></Breadcrumb>
            <div className='inner-page'>

                <div class="container disclosure">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="mainhead">CBSE Mandatory Disclosure</h2>
                            <h3 class="subhead">A: GENERAL INFORMATION</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th width="10%">SL NO.</th>
                                            <th width="45%">INFORMATION</th>
                                            <th width="45%">DETAILS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>NAME OF THE SCHOOL</td>
                                            <td>MATA MARIAM JAN SEVA VIDYALAYA</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>AFFILIATION NO. (IF APPLICABLE)</td>
                                            <td>530271</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>SCHOOL CODE (IF APPLICABLE)</td>
                                            <td>40274</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>4</td>
                                            <td>COMPLETE ADDRESS WITH PIN CODE</td>
                                            <td>


                                                PO. BOX. 6, NASIBPUR, NARNAUL, HARYANA-123001
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>PRINCIPAL NAME &amp; QUALIFICATION:</td>
                                            <td>FR. JOHN MARCUS FERNANDES</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>6</td>
                                            <td>SCHOOL EMAIL ID</td>
                                            <td><a
                                                href="mailto:matamariamjansevavidyalaya@gmail.com">matamariamjansevavidyalaya@gmail.com</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>CONTACT DETAILS (LANDLINE/MOBILE)</td>
                                            <td>9416065213, 9050269525</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h3 class="subhead">B: DOCUMENTS AND INFORMATION</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th width="10%">SL NO.</th>
                                            <th width="65%">SL NO. DOCUMENTS/INFORMATION</th>
                                            <th width="25%">UPLOAD DOCUMENTS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF
                                                ANY</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/CBSE-AFFILIATION.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS
                                                APPLICABLE</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/SOCIETIES-certificate.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>COPIES OF RECOGNITION CERTIFICATE BY THE STATE GOVT./UT</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/recognition.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>

                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>4</td>
                                            <td>COPIES OF MINORITY CERTIFICATE UNDER RTE ACT, 2009 AND ITS RENEWAL IF APPLICABLE</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/minority.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>

                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>COPY OF VALID BUILDING CERTIFICATE</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/building-safety.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>6</td>
                                            <td>COPY OF VALID FIRE SAFETY CERTIFICATE</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/fireSafety.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/deo.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>8</td>
                                            <td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/Drinking-Water.pdf#toolbar=0&navpanes=0"
                                                target="_blank">Click Here</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 class="subhead">C: RESULT AND ACADEMICS</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th width="10%">SL NO.</th>
                                            <th width="65%">SL NO. DOCUMENTS/INFORMATION</th>
                                            <th width="25%">UPLOAD DOCUMENTS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>FEE STRUCTURE OF THE SCHOOL</td>
                                            <td>
                                                <a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/FEE-STRUCTURE.pdf#toolbar=0&navpanes=0"
                                                    target="_blank">Click Here
                                                </a>
                                            </td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>ANNUAL ACADEMIC CALANDER</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/academic-calender.pdf#toolbar=0&navpanes=0" target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>LIST OF SCHOOL MANAGEMENT COMMITTEE</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/PTA.pdf#toolbar=0&navpanes=0" target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>4</td>
                                            <td>LIST OF PTA MEMBERS</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/PTA.pdf#toolbar=0&navpanes=0" target="_blank">Click Here</a></td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>LAST THREE YEAR RESULT OF THE BOARD EXAMINATION</td>
                                            <td><a href="https://webapi.entab.info/api/image/MMJSVN/public/pdf/cbse-result.pdf#toolbar=0&navpanes=0" target="_blank">Click Here</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 class="subhead">CBSE RESULT BEFORE COMPARTMENT <br />RESULT CLASS: X</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Year</th>
                                            <th>No. of students appeard</th>
                                            <th>No. of students passed</th>
                                            <th>No. of students failed</th>
                                            <th>No. of students placed in compartment</th>
                                            <th>No. of students secured above 90%</th>
                                            <th>No. of students secured above 75% - 90%</th>
                                            <th>No. of students secured between 60% - 74%</th>
                                            <th>No. of students secured between 45% - 59%</th>
                                            <th>No. of students secured between 33% - 44%</th>
                                            <th>Pass%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>2021-22</td>
                                            <td>99</td>
                                            <td>99</td>
                                            <td> 0</td>
                                            <td> 0</td>
                                            <td>19</td>
                                            <td>36</td>
                                            <td> 34 </td>
                                            <td>10</td>
                                            <td> 0 </td>
                                            <td>100% </td>

                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>2022-23</td>
                                            <td> 94</td>
                                            <td>94</td>
                                            <td>93</td>
                                            <td> 1 </td>
                                            <td>12</td>
                                            <td> 43</td>
                                            <td> 22</td>
                                            <td>16</td>
                                            <td> 0</td>
                                            <td> 99%</td>

                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>2023-24</td>
                                            <td>88</td>
                                            <td> 87</td>
                                            <td> 0 </td>
                                            <td> 1 </td>
                                            <td> 12</td>
                                            <td> 34</td>
                                            <td> 29</td>
                                            <td> 12</td>
                                            <td> 1 </td>
                                            <td> 99%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 class="subhead">CBSE RESULT BEFORE COMPARTMENT <br />RESULT CLASS: XII</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Year</th>
                                            <th>No. of students appeard</th>
                                            <th>No. of students passed </th>
                                            <th>No. of students failed</th>
                                            <th>No. of students placed in compartment</th>
                                            <th>No. of students secured above 90%</th>
                                            <th>No. of students secured above 75% - 90%</th>
                                            <th>No. of students secured between 60% - 74%</th>
                                            <th>No. of students secured between 45% - 59%</th>
                                            <th>No. of students secured between 33% - 44%</th>
                                            <th>Pass%</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>2021-22</td>
                                            <td>47</td>
                                            <td>47</td>
                                            <td>0</td>
                                            <td>0 </td>
                                            <td>11 </td>
                                            <td>26</td>
                                            <td>8</td>
                                            <td>2 </td>
                                            <td>0 </td>
                                            <td>100% </td>

                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>2022-23</td>
                                            <td>52</td>
                                            <td>48</td>
                                            <td>1</td>
                                            <td>3</td>
                                            <td> 0</td>
                                            <td>22</td>
                                            <td>25</td>
                                            <td>0</td>
                                            <td>1</td>
                                            <td>92%</td>

                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>2023-24</td>
                                            <td>36</td>
                                            <td>31</td>
                                            <td>1</td>
                                            <td>4</td>
                                            <td>5</td>
                                            <td>11</td>
                                            <td>15</td>
                                            <td>5</td>
                                            <td>0</td>
                                            <td>86%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 class="subhead">CBSE RESULT AFTER COMPARTMENT <br />RESULT CLASS: X</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Year</th>
                                            <th>No. of students appeard</th>
                                            <th>No. of students passed</th>
                                            <th>No. of students failed</th>
                                            <th>No. of students placed in compartment</th>
                                            <th>No. of students secured above 90%</th>
                                            <th>No. of students secured above 75% - 90%</th>
                                            <th>No. of students secured between 60% - 74%</th>
                                            <th>No. of students secured between 45% - 59%</th>
                                            <th>No. of students secured between 33% - 44%</th>
                                            <th>Pass%</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>2021-22</td>
                                            <td>99</td>
                                            <td>99</td>
                                            <td> 0</td>
                                            <td> 0</td>
                                            <td>0</td>
                                            <td>0</td>
                                            <td> 0 </td>
                                            <td>0</td>
                                            <td> 0 </td>
                                            <td>100% </td>

                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>2022-23</td>
                                            <td> 94</td>
                                            <td>93</td>
                                            <td>1</td>
                                            <td> 0</td>
                                            <td>0</td>
                                            <td> 0</td>
                                            <td> 0</td>
                                            <td>0</td>
                                            <td> 0</td>
                                            <td> 99%</td>

                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>2023-24</td>
                                            <td>88</td>
                                            <td> 87</td>
                                            <td> 0 </td>
                                            <td> 1 </td>
                                            <td> 12</td>
                                            <td> 34</td>
                                            <td> 29</td>
                                            <td> 12</td>
                                            <td> 0 </td>
                                            <td> 99%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 class="subhead">CBSE RESULT BEFORE COMPARTMENT <br />RESULT CLASS: XII</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Year</th>
                                            <th>No. of students appeard</th>
                                            <th>No. of students passed </th>
                                            <th>No. of students failed</th>
                                            <th>No. of students placed in compartment</th>
                                            <th>No. of students secured above 90%</th>
                                            <th>No. of students secured above 75% - 90%</th>
                                            <th>No. of students secured between 60% - 74%</th>
                                            <th>No. of students secured between 45% - 59%</th>
                                            <th>No. of students secured between 33% - 44%</th>
                                            <th>Pass%</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>2021-22</td>
                                            <td>47</td>
                                            <td>47</td>
                                            <td>0</td>
                                            <td>0 </td>
                                            <td>11 </td>
                                            <td>26</td>
                                            <td>8</td>
                                            <td>2 </td>
                                            <td>0 </td>
                                            <td>100% </td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>2022-23</td>
                                            <td>52</td>
                                            <td>48</td>
                                            <td>1</td>
                                            <td>3</td>
                                            <td> 0</td>
                                            <td>22</td>
                                            <td>25</td>
                                            <td>0</td>
                                            <td>1</td>
                                            <td>92%</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>2023-24</td>
                                            <td>36</td>
                                            <td>31</td>
                                            <td>1</td>
                                            <td>4</td>
                                            <td>5</td>
                                            <td>11</td>
                                            <td>15</td>
                                            <td>0</td>
                                            <td>0</td>
                                            <td>86%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 class="subhead">D: STAFF (TEACHING)</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th width="10%">S.NO.</th>
                                            <th width="60%">INFORMATION</th>
                                            <th width="30%">DETAILS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>PRINCIPAL</td>
                                            <td>FR. JOHN MARCUS FERNANDES</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>TOTAL NO. OF TEACHERS</td>
                                            <td>46</td>
                                        </tr>
                                        <tr>
                                            <td rowspan="3"></td>
                                            <td>PGT</td>
                                            <td>08</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>TGT</td>
                                            <td>17</td>
                                        </tr>
                                        <tr>
                                            <td>PRT</td>
                                            <td>21</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>3</td>
                                            <td>TEACHERS SECTION RATIO</td>
                                            <td>1:40</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>DETAILS OF SPECIAL EDUCATOR</td>
                                            <td>NA</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>5</td>
                                            <td>DETAILS OF COUNSELLOR AND WELNESS TEACHER</td>
                                            <td>P A Rosa</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 class="subhead">E: SCHOOL INFRASTRUCTURE</h3>
                            <div class="tablescroll">
                                <table class="table table-bordered text-center">
                                    <thead class="aos-init aos-animate">
                                        <tr>
                                            <th width="10%">S.NO.</th>
                                            <th width="60%">INFORMATION</th>
                                            <th width="30%">DETAILS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</td>
                                            <td>9578</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>2</td>
                                            <td>NO. AND SIZE OF THE CLASS ROOMS (IN SQUARE MTR)</td>
                                            <td>40, 24-21</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>No. and Size of Laboratories including Computer Labs(in AQMTR)</td>
                                            <td>10, 37-20</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>4</td>
                                            <td>INTERNET FACILITY</td>
                                            <td>YES</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>NO. OF GIRLS TOILETS</td>
                                            <td>40</td>
                                        </tr>
                                        <tr class="aos-init aos-animate">
                                            <td>6</td>
                                            <td>NO. OF BOYS TOILETS</td>
                                            <td>40</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>Link of YouTube Video of the Inspection of School covering the Infrastructure of
                                                the School</td>
                                            <td><a href="https://www.youtube.com/watch?v=gr40NebcZw0" target="_blank">View</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <Footer />
        </>
    )
}
export default CampusInformation